import { useState } from 'react'
import Button from 'components/ui/Button'
import TextField from 'components/ui/TextField'
import getMutationError from 'utils/getMutationError'
import {
  useCustomerLogin,
  CustomerLogin
} from 'components/pages/LoginPage/types/CustomerLogin'

type Customer = NonNullable<
  NonNullable<CustomerLogin['customerLogin']>['customer']
>

type Props = {
  onSuccess: (customer: Customer, redirectTo: string | null) => void
  email: string
}

export default function EmailPasswordForm({ onSuccess, email }: Props) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | undefined>(undefined)
  const [customerLogin] = useCustomerLogin({})

  const onVerifyPassword = async () => {
    if (!password) return
    const response = await customerLogin({
      variables: { password, email, resetTokenAfterLogin: false }
    })
    const mutationError = getMutationError(response!)
    if (mutationError) {
      setError(mutationError)
    } else {
      onSuccess(
        response!.data!.customerLogin!.customer!,
        response!.data!.customerLogin!.redirectTo
      )
    }
  }
  return (
    <>
      <div className="flex items-end justify-between mb-5">
        <div className="grow">
          <TextField
            description="Password"
            error={error}
            name="Password"
            onChange={(event) => setPassword(event.target.value)}
            onKeyDown={(e) => {
              if (e.keyCode !== 13) {
                return
              }
              onVerifyPassword()
            }}
            placeholder="Your password"
            type="password"
            value={password}
          />
        </div>
        <div className="grow mt-1 ml-4">
          <Button
            color="primary"
            onClick={onVerifyPassword}
            size="input"
            variant="contained"
            fullWidth
          >
            Confirm
          </Button>
        </div>
      </div>
    </>
  )
}
